import React from "react";
import { Link } from "react-router-dom";

/**
 * Componente para mostrar la navegación del sitio
 *
 * @component
 */

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid padding-fluid">
        <div className="navbar-header">
          <button
            id="btnMenu"
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link to="/home" aria-label="home">
            <img src="/img/ram.webp" className="img-responsive logo" alt="ram" />{" "}
          </Link>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <Link to="/home">Inicio</Link>
              <a href="#header" className="page-scroll">&nbsp;</a>
            </li> */}
            <li>
              <Link to="/servicios">Servicios</Link>
              <a href="#services" className="page-scroll">&nbsp;</a>
            </li>
            <li>
              <Link to="/news">News</Link>
              <a href="#news" className="page-scroll">&nbsp;</a>
            </li>
            <li>
              <Link to="/nuestrotrabajo">Nuestro Trabajo</Link>
              <a href="#briefcase" className="page-scroll">&nbsp;</a>
            </li>
            <li>
              <Link to="/newsletter">Newsletter</Link>
              <a href="#newsletter" className="page-scroll">&nbsp;</a>
            </li>
            <li>
              <Link to="/clientes">Clientes</Link>
              <a href="#clients" className="page-scroll">&nbsp;</a>
            </li>
            <li>
              <Link to="/equipo">Equipo</Link>
              <a href="#team" className="page-scroll">&nbsp;</a>
            </li>
            <li>
              <a href="#contactanos">
                Contáctanos
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
